import { render, staticRenderFns } from "./BindGroup.vue?vue&type=template&id=439e58e6&scoped=true"
import script from "./BindGroup.vue?vue&type=script&lang=js"
export * from "./BindGroup.vue?vue&type=script&lang=js"
import style0 from "./BindGroup.vue?vue&type=style&index=0&id=439e58e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e58e6",
  null
  
)

export default component.exports